// pages/UserActivityLogsPage.jsx

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { Link, useLocation } from "react-router-dom";
import AdminHeader from "../components/AdminHeader";

export default function UserActivityLogsPage() {
  const { userId } = useParams();
  const [logs, setLogs] = useState([]);
  const location = useLocation();


  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const q = query(
          collection(db, "users", userId, "activityLogs"),
          orderBy("timestamp", "desc")
        );
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setLogs(data);
      } catch (err) {
        console.error("Error fetching logs:", err);
      }
    };

    fetchLogs();
  }, [userId]);

  const navItems = [
    { name: "Site Config", path: "/admin" },
    { name: "User Manager", path: "/admin/users" },
  ];

  return (
    <>
    <AdminHeader />
    <div className="flex flex-col md:flex-row bg-black text-white">
      {/* Sidebar */}
      <div className="w-full md:w-48 bg-black border-b md:border-b-0 md:border-r border-[#D4FF00]/30 p-4">
        <h2 className="text-lg font-bold text-[#D4FF00] mb-4">Admin</h2>
        <nav className="space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`block rounded px-3 py-2 text-sm font-medium transition ${location.pathname === item.path
                ? "bg-[#D4FF00] text-black"
                : "text-gray-300 hover:bg-[#D4FF00]/20"
                }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </div>
      <div className="p-6 w-full md:w-full lg:max-w-[1200px]">
        <h2 className="text-xl font-bold text-[#D4FF00] mb-3">Activity Logs for User</h2>
        {logs.length === 0 ? (
          <p className="text-gray-400">No activity recorded.</p>
        ) : (
          <div className="space-y-3">
            {logs.map((log) => (
              <div
                key={log.id}
                className="border border-white/10 p-3 rounded-md bg-neutral-900"
              >
                <div className="text-white font-medium">{log.action}</div>
                {log.details && (
                  <div className="text-sm text-gray-300">{log.details}</div>
                )}
                <div className="text-xs text-gray-500">
                  {log.timestamp?.toDate?.().toLocaleString?.() || "—"}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
    </>
  );

}
